import { Typography } from "@mui/material";

export function TextCell({ item, color, ...props }) {
  return (
    <Typography
      variant="h5"
      component="span"
      color={color || "text.main"}
      {...props}
    >
      {item}
    </Typography>
  );
}
export default TextCell;
